import React, { Component } from "react";
import { Select, Button, Form, message } from "antd";
import { connect } from "react-redux";
import { professionalAction } from "../../_actions";

const { Option } = Select;

class Createmoda extends Component {
  state = {
    heads: [],
    sub_heads: [],
    selectedHead: null,
    selectedSubHead: [],
  };

  getMainHead = () => {
    professionalAction.getMainHead().then((res) => {
      this.setState({
        heads: res.data,
      });
    });
  };
  getCrimeSubTitleByTitle = (id) => {
    professionalAction.getCrimeSubTitleByTitle(id).then((res) => {
      console.log("res", res.pc_crimetypes);
      this.setState({
        sub_heads: res.pc_crimetypes,
      });
    });
  };
  componentDidMount = () => {
    this.getMainHead();
  };
  handleHeadChange = (value) => {
    this.setState(
      {
        selectedHead: value,
        selectedSubHead: [],
      },
      () => {
        this.getCrimeSubTitleByTitle(value);
      }
    );
  };

  handleSubHeadChange = (value) => {
    this.setState({ selectedSubHead: value });
  };

  handleSubmit = () => {
    const { selectedHead, selectedSubHead } = this.state;
    let obj = {
      head_id: selectedHead,
      sub_head_id: selectedSubHead,
    };
    professionalAction
      .CreateModasoperandi(obj)
      .then((res) => {
        console.log("res", res);
        if (res.status === 409) {
          message.error(res.message);
        } else {
          message.success("Create Successfully");
        }
        this.props.close();
        this.props.ListModasoperandi();
        this.props.getShowList("list");
        this.setState({
          selectedHead: null,
          selectedSubHead: [],
        });
      })
      .catch((error) => {
        console.log("error", error);
      });

    console.log("Selected Header:", selectedHead);
    console.log("Selected Sub Header:", selectedSubHead);
  };

  render() {
    const { heads, sub_heads, selectedHead, selectedSubHead } = this.state;
    console.log(sub_heads, "sub_heads");
    return (
      <Form layout="vertical">
        {/* Header Dropdown */}
        <Form.Item label="Header">
          <Select
            placeholder="Select Header"
            value={selectedHead}
            onChange={this.handleHeadChange}
            allowClear
          >
            {heads.map((item) => (
              <Option key={item.title_id} value={item.title_id}>
                {item.main_head_type}
              </Option>
            ))}
          </Select>
        </Form.Item>

        {/* Sub Header Dropdown */}
        {selectedHead && (
          <Form.Item label="Sub Header">
            <Select
              placeholder="Select Sub Header"
              value={selectedSubHead || []}
              onChange={this.handleSubHeadChange}
              allowClear
              mode="multiple"
            >
              {sub_heads?.map((item) => {
                const isDisabled = this.props.data?.some(
                  (d) => d.sub_head_id === item.id
                );

                return (
                  <Option key={item.id} value={item.id} disabled={isDisabled}>
                    {item.crimetype}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
        )}

        {/* Submit Button */}
        <Form.Item>
          <Button
            type="primary"
            onClick={this.handleSubmit}
            disabled={!selectedHead || !selectedSubHead}
          >
            Submit
          </Button>
        </Form.Item>
      </Form>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;

  return {
    user,
    users,
    professionals,
  };
}

export default connect(mapStateToProps)(Createmoda);
